<div class="middle-box text-center loginscreen">
    <h2>Please wait...</h2>
</div>
